import { ScriptDark } from './ScriptDark';

export default ScriptDark;
